// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"EmailDealResult__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/EmailDeal/EmailDealResult.scss
 ** module id = 915
 ** module chunks = 1
 **/